import React, { useState } from 'react';
import { estadosDisponibles } from '@/config/constants';

const StatusChangeModal = ({ currentStatus, solicitudId, onClose, onStatusChanged }) => {
    const [newStatus, setNewStatus] = useState(currentStatus);
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
  
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/applications/${solicitudId}/status`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            new_status: newStatus,
            reason: reason || `Estado cambiado a ${newStatus}`
          })
        });
  
        if (response.ok) {
          onStatusChanged();
        } else {
          const error = await response.json();
          success(`❌ Error: ${error.detail}`);
        }
      } catch (error) {
        success('❌ Error cambiando estado');
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg max-w-md w-full mx-4">
          <div className="p-6 border-b border-gray-200">
            <h3 className="text-xl font-bold text-gray-900">Cambiar Estado</h3>
          </div>
  
          <form onSubmit={handleSubmit} className="p-6">
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Estado Actual: <span className="font-bold">{currentStatus}</span>
              </label>
            </div>
  
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nuevo Estado *
              </label>
              <select
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg"
                required
              >
                {estadosDisponibles.map((estado) => (
                  <option key={estado.id} value={estado.id}>
                    {estado.name}
                  </option>
                ))}
              </select>
            </div>
  
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Motivo del Cambio
              </label>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg"
                rows="3"
                placeholder="Explica el motivo del cambio de estado..."
              />
            </div>
  
            <div className="flex space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 bg-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-400"
              >
                Cancelar
              </button>
              <button
                type="submit"
                disabled={loading}
                className="flex-1 bg-purple-600 text-white py-2 px-4 rounded-lg hover:bg-purple-700 disabled:opacity-50"
              >
                {loading ? 'Actualizando...' : 'Cambiar Estado'}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

export default StatusChangeModal;